import { render, staticRenderFns } from "./Maternity.vue?vue&type=template&id=5132baa2"
import script from "./Maternity.vue?vue&type=script&lang=js"
export * from "./Maternity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports